import { AxiosResponse } from 'axios';
import omit from 'lodash/omit';

import { DEFAULT_QUERY_LIMIT } from '@cvt/helpers/query';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';
import { request } from '@cvt/clients/baseClient';
import { mapStoryDataForApi } from '@modules/Stories/client/helpers';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getStories = (params: Stories.GetListParams): Promise<AxiosResponse<CVT.Query.PaginatedResults<Stories.Story>>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/stories/`,
      method: 'GET',
      params: {
        search: params.search,
        status: params.status,
        type: params.type,
        tags__name: params.tags,
        limit: params.limit || DEFAULT_QUERY_LIMIT,
        offset: params.offset,
      },
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResultsApi<Stories.StoryApi>>) => ({
    ...data,
    data: {
      ...omit(data.data, ['results', 'absolute_total']),
      absoluteTotal: data.data.absolute_total,
      results: data.data.results.map(camelizeObject<Stories.Story>),
    },
  }));
};

const getStory = (params: { id: number | string }): Promise<AxiosResponse<Stories.Story>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/stories/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Stories.StoryApi>) => ({
    ...data,
    data: camelizeObject<Stories.Story>(data.data),
  }));
};

const createStory = (data: Partial<Stories.Create>): Promise<AxiosResponse<Stories.Story>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/stories/`,
      method: 'POST',
      data: snakizeObject<Stories.StoryApi>(mapStoryDataForApi(data)),
    },
  }).then((data: AxiosResponse<Stories.StoryApi>) => ({
    ...data,
    data: camelizeObject<Stories.Story>(data.data),
  }));
};

const editStory = (data: Stories.Edit): Promise<AxiosResponse<Stories.Story>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/stories/${data.id}/`,
      method: 'PUT',
      data: snakizeObject<Stories.StoryApi>(mapStoryDataForApi(data)),
    },
  });
};

const deleteStory = (params: { id: number | string }): Promise<AxiosResponse> => {
  return request({
    options: {
      url: `${apiBaseUrl}/stories/${params.id}/`,
      method: 'DELETE',
    },
  });
};

export const storyClient = {
  getStories,
  getStory,
  createStory,
  editStory,
  deleteStory,
};
